import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { State } from 'state';
import { sendNewSignupLink } from 'state/actions/complete-signup';
import { getIsNewSignupLinkBeingSent } from 'state/selectors/complete-signup';
import CompleteSignupExpiredTokenScreenComponent from './complete-signup-expired-token-screen';

const selector = createSelector(
    (state: State) => getIsNewSignupLinkBeingSent(state),
    (isNewSignupLinkBeingSent) => ({
        isNewSignupLinkBeingSent,
    })
);

export default connect(selector, {
    sendNewSignupLinkAction: sendNewSignupLink,
})(CompleteSignupExpiredTokenScreenComponent);
